import * as ko from "knockout"
import 'jquery';

export class ScrollFixerExtention {
	static Init() {
		ko.bindingHandlers.scrollFixer = {
			init: (element, valueAccessor) => {
				element.style.overflowY = 'auto';

				element.addEventListener('wheel', function (e: WheelEvent) {
					const canScrollDown = element.scrollTop + element.clientHeight < element.scrollHeight;
					const canScrollUp = element.scrollTop > 0;
					const goingDown = e.deltaY > 0;
					const goingUp = e.deltaY < 0;

					if ((goingDown && canScrollDown) || (goingUp && canScrollUp)) {
						element.scrollTop += e.deltaY;
						e.preventDefault();
					}
				}, { passive: false });
			}
		};
	}
}
